import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Offcanvas from "../../../components/common/SwipeableOffcanvas";
import { criarPost } from "../../social/postsService";
import ShareRefeicao from "../../nutricao/components/ShareRefeicao";
import s from "./WorkoutShare.module.scss";

export default function WorkoutShare({ workout, profileData, onClose }) {
  const [caption, setCaption] = useState(workout.description || "");
  const [confirmClose, setConfirmClose] = useState(false);
  const [external, setExternal] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  /* Publicado, mas AINDA NÃO no feed: a foto entra em análise antes. Fechar
     em silêncio faria a pessoa procurar no feed um post que não está lá. */
  const [emAnalise, setEmAnalise] = useState(false);
  const locked = useRef(false);
  const publish = async () => {
    if (locked.current || !workout.photo_url) return;
    locked.current = true;
    setBusy(true);
    setError("");
    try {
      await criarPost({
        fotoUrl: workout.photo_url,
        legenda: caption,
        local: workout.location,
        tipo: "TREINO",
        registroId: workout.id,
      });
    } catch (e) {
      locked.current = false;
      setBusy(false);
      setError(
        e?.message ||
          "Não foi possível compartilhar. Seu treino continua salvo."
      );
      return;
    }
    setBusy(false);
    setEmAnalise(true);
  };
  const requestClose = () => {
    if (!locked.current) setConfirmClose(true);
  };
  const minutes = workout.atividades.reduce(
    (sum, a) => sum + Number(a.duration_min || 0),
    0
  );
  return (
    <>
      <Offcanvas
        show
        placement="end"
        className={s.sheet}
        onHide={requestClose}
        backdrop={false}
      >
        <Offcanvas.Header className={s.header}>
          <button onClick={requestClose} disabled={busy} aria-label="Fechar">
            ×
          </button>
          <Offcanvas.Title>Compartilhar no feed</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className={s.body}>
          <div className={s.photo}>
            {workout.photo_url && (
              <img src={workout.photo_url} alt="Foto do treino" />
            )}
            <div className={s.caption}>
              <span>TREINO REGISTRADO</span>
              <h2>{workout.title}</h2>
              <p>
                {Math.round(minutes)} min · +{workout.xp_earned || 0} XP
              </p>
            </div>
          </div>
          {emAnalise ? (
            <div className={s.hint} role="status">
              <strong>Foto em análise.</strong> Toda foto passa por uma
              checagem rápida antes de entrar no feed. Assim que for aprovada,
              o post aparece para todo mundo e o XP entra na sua conta.
            </div>
          ) : null}
          <label className={s.field} hidden={emAnalise}>
            LEGENDA
            <textarea
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              maxLength={2200}
              placeholder="Escreva algo sobre o treino…"
              disabled={busy}
            />
          </label>
          {!workout.photo_url && (
            <p className={s.hint}>
              Seu treino está salvo. Adicione uma foto pela edição do check-in
              para compartilhar no feed.
            </p>
          )}
          {error && (
            <p role="alert" className={s.error}>
              {error}
            </p>
          )}
          {emAnalise ? (
            <button className={s.primary} onClick={onClose}>
              Entendi
            </button>
          ) : (
            <button
              className={s.primary}
              onClick={publish}
              disabled={busy || !workout.photo_url}
            >
              {busy ? "Compartilhando…" : "Compartilhar no feed"}
            </button>
          )}
          <button
            className={s.secondary}
            disabled={busy}
            onClick={() => setExternal(true)}
          >
            Stories e baixar imagem
          </button>
        </Offcanvas.Body>
      </Offcanvas>
      <Modal
        show={confirmClose}
        onHide={() => setConfirmClose(false)}
        centered
        className={s.confirm}
      >
        <Modal.Body>
          <span className={s.check}>✓</span>
          <h2>Seu treino já está salvo</h2>
          <p>
            Ao fechar, ele não será publicado no feed. Você pode compartilhar
            depois.
          </p>
          <button className={s.primary} onClick={() => setConfirmClose(false)}>
            Voltar e compartilhar
          </button>
          <button className={s.secondary} onClick={onClose}>
            Fechar sem compartilhar
          </button>
        </Modal.Body>
      </Modal>
      {external && (
        <Offcanvas
          show
          placement="end"
          className={s.sheet}
          onHide={() => setExternal(false)}
        >
          <Offcanvas.Header>
            <button className={s.secondary} onClick={() => setExternal(false)}>
              Voltar
            </button>
          </Offcanvas.Header>
          <Offcanvas.Body className={`${s.body} ${s.fullBody}`}>
            <ShareRefeicao
              type="workout"
              workout={workout}
              profileData={profileData}
            />
          </Offcanvas.Body>
        </Offcanvas>
      )}
    </>
  );
}
